/* Gassas note links (assets/gassas-note-links.js).
   Turns the notes in the Doftpyramid section into links to their note profile pages (/pages/noter/<note>).
   Needs assets/doftfinder-notes.js first. */
(function () {
  'use strict';
  var G = window.GassasNotes;
  if (!G) return;
  var lang = String(document.documentElement.lang || 'sv').slice(0, 2).toLowerCase();
  var LABEL = {
    sv: 'Notprofil för ',
    da: 'Læs mere om noten ',
    nb: 'Les mer om noten ',
    no: 'Les mer om noten ',
    nn: 'Les mer om noten '
  };
  var label = LABEL[lang] || 'Note profile for ';

  function linkNotes() {
    var items = document.querySelectorAll('.gassas-notes__note');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (li.querySelector('.gn-link')) continue;
      var labelEl = li.querySelector('.gassas-notes__label');
      if (!labelEl) continue;
      var text = labelEl.textContent.trim();
      var n = G.classify(text);
      if (!n || !n.known) continue;
      var a = document.createElement('a');
      a.className = 'gn-link';
      a.href = G.profileUrl(n.id);
      a.setAttribute('aria-label', label + text);
      while (li.firstChild) a.appendChild(li.firstChild);
      li.appendChild(a);
    }
  }

  linkNotes();
  document.addEventListener('shopify:section:load', linkNotes);
})();